import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { urlClassif } from 'src/app/common';
import { Classification } from 'src/app/models/obs/classification';

@Injectable({
  providedIn: 'root'
})
export class ClassificationService {

  constructor( private http: HttpClient ) { }

  getAll(){
    return this.http.get(`${urlClassif}/get-all`);
  }

  getOne(id: string){
    return this.http.get(`${urlClassif}/get-one/${id}`);
  }

  create(data: Classification): Observable<Classification>{
    return this.http.post(`${urlClassif}/create`, data);
  }

  update(id: string, data: Classification): Observable<Classification>{
    return this.http.put(`${urlClassif}/update/${id}`, data);
  }

  delete(id: string){
    return this.http.delete(`${urlClassif}/delete/${id}`);
  }
}
